<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Video Content</h1>
        <div class="description">
          <h2><i>Coming Soon!</i></h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },

    methods: {
    }
  };
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/keyboard.png');
  }
</style>